export const COLORS = {
  blue: "#84C0D2",
  skyBlue: "#EAF6F9",
  red: "#FF7B6F",
  pink: "#F09F97",
  yellow: "#F5BA49",
  black: "#143742",
  darkBlue: "#275563",
  silver: "#EAEDEF",
  white: "#fff",
  whiteGreen: "#D5F7CB",
  green: "#74CB5A"
};
